/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputUavMissionLoiterArea } from './InputUavMissionLoiterArea';
import {
    InputUavMissionLoiterAreaFromJSON,
    InputUavMissionLoiterAreaFromJSONTyped,
    InputUavMissionLoiterAreaToJSON,
} from './InputUavMissionLoiterArea';
import type { InputUavMissionWaypoint } from './InputUavMissionWaypoint';
import {
    InputUavMissionWaypointFromJSON,
    InputUavMissionWaypointFromJSONTyped,
    InputUavMissionWaypointToJSON,
} from './InputUavMissionWaypoint';

/**
 * 
 * @export
 * @interface InputUavMission
 */
export interface InputUavMission {
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    altitude?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    comment?: string;
    /**
     * CrewCallsign — позивний екіпажу вільним вводом: якщо такого в довіднику немає,
     * він створюється (services.ResolveOrCreateCrew), як це робить парсер Element-заявок.
     * @type {string}
     * @memberof InputUavMission
     */
    crewCallsign?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    destinationArea?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    flightDate?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    freqControl?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    freqVideo?: string;
    /**
     * LaunchNow — екіпаж не планує виліт, а злітає просто зараз: заявка створюється одразу
     * в повітрі (airborne_outbound + airborne_at), без проміжного awaiting_launch.
     * Це головний сценарій сторінки екіпажу: раніше про такий виліт повідомляли по рації,
     * і в системі він з'являвся вже постфактум. Погодження не потребує — черговий бачить
     * борт на мапі в ту ж секунду.
     * @type {boolean}
     * @memberof InputUavMission
     */
    launchNow?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    launchSite?: string;
    /**
     * Loiter — район розвідки (баражування). Обов'язковий для розвідників (uav_platforms.type
     * = recon) — саме там борт працює до доповіді про повернення; для решти типів опційний.
     * @type {InputUavMissionLoiterArea}
     * @memberof InputUavMission
     */
    loiter?: InputUavMissionLoiterArea;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    pilot?: string;
    /**
     * Points — маршрут польоту. Перша точка — місце запуску, остання — найдальша точка завдання.
     * @type {Array<InputUavMissionWaypoint>}
     * @memberof InputUavMission
     */
    points: Array<InputUavMissionWaypoint>;
    /**
     * StreamURL — не обов'язково посилання: у полі буває й вільний опис («стрім у Вежі,
     * канал 3»), тому перевіряємо лише довжину. Картка сама вирішує, чи це відкривне
     * посилання (BuildUavMissionOutput -> чіп «Відкрити»), чи просто текст.
     * @type {string}
     * @memberof InputUavMission
     */
    streamUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    timeWindow?: string;
    /**
     * 
     * @type {number}
     * @memberof InputUavMission
     */
    uavPlatformId: number;
    /**
     * UavUnit — підрозділ БпЛА вільним вводом. Командир його не вказує: підрозділ заявки
     * виводиться з його власного (user.Division). Поле для адміна, який подає заявку не від
     * себе й підрозділу не має взагалі — інакше картка показувала б «Підрозділ не розпізнано».
     * Від решти ролей значення ігнорується, щоб ніхто не подавав заявку від чужого підрозділу.
     * @type {string}
     * @memberof InputUavMission
     */
    uavUnit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputUavMission
     */
    usesDroneId?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputUavMission
     */
    workType?: InputUavMissionWorkTypeEnum;
}


/**
 * @export
 */
export const InputUavMissionWorkTypeEnum = {
    Reconnaissance: 'reconnaissance',
    Adjustment: 'adjustment',
    Bombing: 'bombing',
    Strike: 'strike',
    Retranslation: 'retranslation',
    Ew: 'ew'
} as const;
export type InputUavMissionWorkTypeEnum = typeof InputUavMissionWorkTypeEnum[keyof typeof InputUavMissionWorkTypeEnum];


/**
 * Check if a given object implements the InputUavMission interface.
 */
export function instanceOfInputUavMission(value: object): boolean {
    if (!('points' in value)) return false;
    if (!('uavPlatformId' in value)) return false;
    return true;
}

export function InputUavMissionFromJSON(json: any): InputUavMission {
    return InputUavMissionFromJSONTyped(json, false);
}

export function InputUavMissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMission {
    if (json == null) {
        return json;
    }
    return {
        
        'altitude': json['altitude'] == null ? undefined : json['altitude'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'crewCallsign': json['crewCallsign'] == null ? undefined : json['crewCallsign'],
        'destinationArea': json['destinationArea'] == null ? undefined : json['destinationArea'],
        'flightDate': json['flightDate'] == null ? undefined : json['flightDate'],
        'freqControl': json['freqControl'] == null ? undefined : json['freqControl'],
        'freqVideo': json['freqVideo'] == null ? undefined : json['freqVideo'],
        'launchNow': json['launchNow'] == null ? undefined : json['launchNow'],
        'launchSite': json['launchSite'] == null ? undefined : json['launchSite'],
        'loiter': json['loiter'] == null ? undefined : InputUavMissionLoiterAreaFromJSON(json['loiter']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'pilot': json['pilot'] == null ? undefined : json['pilot'],
        'points': ((json['points'] as Array<any>).map(InputUavMissionWaypointFromJSON)),
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'timeWindow': json['timeWindow'] == null ? undefined : json['timeWindow'],
        'uavPlatformId': json['uavPlatformId'],
        'uavUnit': json['uavUnit'] == null ? undefined : json['uavUnit'],
        'usesDroneId': json['usesDroneId'] == null ? undefined : json['usesDroneId'],
        'workType': json['workType'] == null ? undefined : json['workType'],
    };
}

export function InputUavMissionToJSON(value?: InputUavMission | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'altitude': value['altitude'],
        'comment': value['comment'],
        'crewCallsign': value['crewCallsign'],
        'destinationArea': value['destinationArea'],
        'flightDate': value['flightDate'],
        'freqControl': value['freqControl'],
        'freqVideo': value['freqVideo'],
        'launchNow': value['launchNow'],
        'launchSite': value['launchSite'],
        'loiter': InputUavMissionLoiterAreaToJSON(value['loiter']),
        'phone': value['phone'],
        'pilot': value['pilot'],
        'points': ((value['points'] as Array<any>).map(InputUavMissionWaypointToJSON)),
        'streamUrl': value['streamUrl'],
        'timeWindow': value['timeWindow'],
        'uavPlatformId': value['uavPlatformId'],
        'uavUnit': value['uavUnit'],
        'usesDroneId': value['usesDroneId'],
        'workType': value['workType'],
    };
}

